var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasArchiveStateStatus)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":"#B3C2D6","small":_vm.small}},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.stateIcon))])]}}],null,false,2007352722)},[_c('span',[_vm._v(_vm._s(_vm.stateInfo))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }